import React from 'react';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import purchaseOrderConfig from './config/purchaseOrderConfig';
import setViewTitle from '../../helpers/setViewTitle';
import Widget from '../common/Widget';
import CommentsWidget from '../common/CommentsWidget';
import DocumentsCollection from '../common/DocumentsCollection';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var PurchaseOrderHistoryEntry = createReactClass({

  getInitialState() {
    return {
      hasBeenFound: false,
    };
  },

  componentWillMount() {
    setViewTitle('Bestellungen');
  },

  componentDidMount() {
    request.get({
      url: purchaseOrderConfig.apiUrl + 'history/' + this.props.match.params.id,
      success: data => {
        if (this.isMounted()) {
          this.setState({
            hasBeenFound: true,
            ...data
          });
        }
      }
    });
  },

  render() {
    if (!this.state.hasBeenFound) {
      return null;
    }

    const order = this.state.purchaseOrder;

    var displayLines = order.lines.map(line =>
      <tr key={line.itemId}>
          <td>{line.itemName}</td>
          <td>{line.purchaseUnitQuantity}</td>
          <td>{line.purchaseUnitName}</td>
          <td>{line.lineNetPrice}</td>
      </tr>
    );

    var displayNewLines = order.newLines.map(line =>
      <tr key={line.itemName}>
          <td>{line.itemName}</td>
          <td>{line.purchaseUnitQuantity}</td>
          <td>{line.purchaseUnitName}</td>
          <td>{line.lineNetPrice}</td>
      </tr>
    );

    const checkBoxStyles = {
      marginLeft: '8px',
      marginTop: '10px',
      marginBottom: '10px',
      width: '200px'
    };


    const formTitle = order.orderWithoutStorage ? 'Bestellungsübersicht - Ohne Lagerführung' : 'Bestellungsübersicht';
    const bestellungBody = order.orderWithoutStorage && order.price !== undefined && order.price !== null ? (
      <div style={{ padding: '10px' }}>
        <strong style={{ marginRight: '.5em' }}>Bestellsumme:</strong>
        <span>€ {order.price}</span>
      </div>
    ) : (
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead>
          <tr>
            <th>Artikel</th>
            <th>Bestellmenge</th>
            <th>Bestelleinheit</th>
            <th>Preis</th>
          </tr>
          </thead>
          <tbody>
          {displayLines}
          {displayNewLines}
          </tbody>
        </table>
      </div>
    );

    return (
      <div>
        <div className="row">
          <Widget title={formTitle} bodyClassName="min-height-auto">
            {bestellungBody}
          </Widget>
        </div>
        <div className="row">
          <CommentsWidget
            apiUrl="unused"
            containerClassName="col-md-12"
            beforeSubmit={() => {}}
            claim="purchaseordershistory:write"
            fixedComments={order.comments}
          />
        </div>
        <div className="row">
          <DocumentsCollection
            documents={order.documents}
            onDoumentDeleted={() => {}}
            onDocumentUploaded={() => {}}
            deleteUrlBase="unused"
            viewUrlBase={`${purchaseOrderConfig.apiUrl}history/${this.props.match.params.id}`}
            uploadUrlBase="unused"
            claim="purchaseordershistory:write"
          />
        </div>
      </div>
    );
  }
});

export default AjaxInProgressHOC(PurchaseOrderHistoryEntry);



// WEBPACK FOOTER //
// ./src/components/purchaseorders/PurchaseOrderHistoryEntry.js